import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import StockStats from './stock-stats';

const StockStatsWidget = () => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <StockStats />
    </QueryClientProvider>
  );
};

export { StockStatsWidget }
